module.exports = new __parcel__URL__("coinbase.55ac22d5.webp").toString();